import React, {useState} from 'react';
import {Col, Row, DatePicker, Checkbox} from 'antd';
import InputField from '../../../../input-field';
import DividerBlock from "../../../../divider-block";
import SelectField from "../../../../select-field";
import CorrespondentBankFields from './correspondent-bank-fields';
import i18n from "../../../../../i18n";

export default function MainDataFields({ stepFields, setFields, getFieldErrors, orgFormId, edit = false }) {
    const [notRegisteredATI, setNotRegisteredATI] = useState(false);

    const firstToUpper = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    const ndsList = [
        {
            Id: 1,
            Name: i18n.t('constants.ndsList.1')
        },
        {
            Id: 2,
            Name: i18n.t('constants.ndsList.2')
        }
    ];

    return (
        <>
          <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
            <Col lg={8} sm={24}>
              <InputField
                name="name"
                title={i18n.t('modals.modalEditLegalEntityNew.fields.name.title')}
                label={i18n.t('modals.modalEditLegalEntityNew.fields.name.title')}
                required={true}
                value={stepFields.name}
                setValue={(value) => {setFields({...stepFields, name: value});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
              <Col lg={8} sm={24}>
                  <InputField
                      name="legalNumber"
                      title={i18n.t('modals.modalEditLegalEntityNew.fields.legalNumber.title')}
                      label={i18n.t('modals.modalEditLegalEntityNew.fields.legalNumber.label')}
                      required={true}
                      value={stepFields.legalNumber}
                      setValue={(value) => {setFields({...stepFields, legalNumber: value});}}
                      getFieldErrors={getFieldErrors}
                  />
              </Col>
              <Col lg={8} sm={24}>
                  <SelectField
                      title={i18n.t('modals.modalEditLegalEntityNew.fields.workWithNds.title')}
                      name="workWithNds"
                      selectedValue={stepFields.workWithNds}
                      values={ndsList}
                      onChange={(value) => {
                          setFields({
                              ...stepFields,
                              workWithNds: value,
                          });
                      }}
                      getErrors={getFieldErrors}
                      placeholder={i18n.t('modals.modalEditLegalEntityNew.fields.workWithNds.placeholder')}
                      notFoundText={null}
                      showArrow={true}
                      style={{ width: "100%" }}
                  />
              </Col>
          </Row>
          <DividerBlock label={i18n.t('modals.modalEditLegalEntityNew.divider.signatory')} />
          <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
            <Col lg={8} sm={24}>
              <InputField
                name="firstName"
                title={i18n.t('modals.modalEditLegalEntityNew.fields.firstName.title')}
                label={i18n.t('modals.modalEditLegalEntityNew.fields.firstName.title')}
                required={true}
                value={stepFields.firstName}
                setValue={(value) => {setFields({...stepFields, firstName: firstToUpper(value)});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                name="secondName"
                title={i18n.t('modals.modalEditLegalEntityNew.fields.secondName.title')}
                label={i18n.t('modals.modalEditLegalEntityNew.fields.secondName.title')}
                required={true}
                value={stepFields.secondName}
                setValue={(value) => {setFields({...stepFields, secondName: firstToUpper(value)});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                name="patronymic"
                title={i18n.t('modals.modalEditLegalEntityNew.fields.patronymic.title')}
                label={i18n.t('modals.modalEditLegalEntityNew.fields.patronymic.title')}
                required={true}
                value={stepFields.patronymic}
                setValue={(value) => {setFields({...stepFields, patronymic: firstToUpper(value)});}}
                getFieldErrors={getFieldErrors}
              />
            </Col>
              { orgFormId !== 16 ?
                  <>
                      <Col lg={8} sm={24} >
                          <InputField name="position" label={i18n.t('modals.modalEditLegalEntityNew.fields.position.title')} value={stepFields.position} setValue={value => setFields({...stepFields, position: firstToUpper(value)})} getFieldErrors={getFieldErrors} />
                      </Col>
                      <Col lg={8} sm={24} >
                          <SelectField
                              title={i18n.t('modals.modalEditLegalEntityNew.fields.legalReason.title')}
                              name="legalReason"
                              selectedValue={stepFields.legalReason}
                              values={stepFields.legalReasonsList}
                              onChange={(value) => {
                                  setFields({
                                      ...stepFields,
                                      legalReason: value,
                                  });
                              }}
                              getErrors={getFieldErrors}
                              placeholder={i18n.t('modals.modalEditLegalEntityNew.fields.legalReason.placeholder')}
                              notFoundText={null}
                              showArrow={true}
                              style={{ width: "100%" }}
                          />
                      </Col>
                  </> :
                  <>
                      <Col lg={8} sm={24} >
                          <InputField
                              name="legalReason"
                              isDisabled={true}
                              label={i18n.t('modals.modalEditLegalEntityNew.fields.legalReason.title')}
                              value={i18n.t('modals.modalEditLegalEntityNew.fields.legalReason.value')}
                              setValue={value => setFields({...stepFields, legalReason: value})}
                              getFieldErrors={getFieldErrors}
                          />
                      </Col>
                  </>
              }
          </Row>
          <DividerBlock label="Банк" />
          <Row gutter={[{ xs: 0, sm: 0, md: 16}, 24]}>
            <Col lg={8} sm={24}>
              <InputField
                  name="bankName"
                  title={i18n.t('modals.modalEditLegalEntityNew.fields.bankName.title')}
                  label={i18n.t('modals.modalEditLegalEntityNew.fields.bankName.title')}
                  required={true}
                  value={stepFields.bankName}
                  setValue={(value) => {setFields({...stepFields, bankName: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="accountNumber"
                  title={i18n.t('modals.modalEditLegalEntityNew.fields.accountNumber.title')}
                  label={i18n.t('modals.modalEditLegalEntityNew.fields.accountNumber.title')}
                  required={true}
                  value={stepFields.accountNumber}
                  setValue={(value) => {setFields({...stepFields, accountNumber: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
              <Col lg={8} sm={24}>
                  <InputField
                      name="bankUnp"
                      label={i18n.t('modals.modalEditLegalEntityNew.fields.bankUnp.title')}
                      title={i18n.t('modals.modalEditLegalEntityNew.fields.bankUnp.title')}
                      required={true}
                      value={stepFields.bankUnp}
                      setValue={(value) => {setFields({...stepFields, bankUnp: value});}}
                      getFieldErrors={getFieldErrors}
                  />
              </Col>
              <Col lg={8} sm={24}>
                  <InputField
                      name="bic"
                      label={i18n.t('modals.modalEditLegalEntityNew.fields.bic.title')}
                      title={i18n.t('modals.modalEditLegalEntityNew.fields.bic.title')}
                      required={true}
                      value={stepFields.bic}
                      setValue={(value) => {setFields({...stepFields, bic: value});}}
                      getFieldErrors={getFieldErrors}
                  />
              </Col>
            <Col lg={8} sm={24}>
              <InputField
                  name="swift"
                  label={i18n.t('modals.modalEditLegalEntityNew.fields.swift.title')}
                  required={true}
                  value={stepFields.swift}
                  setValue={(value) => {setFields({...stepFields, swift: value});}}
                  getFieldErrors={getFieldErrors}
              />
            </Col>
              <Col lg={24} sm={24}>
                  <InputField
                      name="bankAddress"
                      label={i18n.t('modals.modalEditLegalEntityNew.fields.bankAddress.title')}
                      title={i18n.t('modals.modalEditLegalEntityNew.fields.bankAddress.title')}
                      required={true}
                      value={stepFields.bankAddress}
                      setValue={(value) => {setFields({...stepFields, bankAddress: value});}}
                      getFieldErrors={getFieldErrors}
                  />
              </Col>
          </Row>
            <CorrespondentBankFields
                setFields={setFields}
                stepFields={stepFields}
                getFieldErrors={getFieldErrors}
                edit={true}
            />
          <DividerBlock label={i18n.t('modals.modalEditLegalEntityNew.divider.details')} />
          <Row>
          </Row>
            <Row>
                <Col lg={8} sm={24}>
                    <InputField
                        name="phone"
                        title={i18n.t('modals.modalEditLegalEntityNew.fields.phone.title')}
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.phone.title')}
                        required={true}
                        value={stepFields.phone}
                        setValue={(value) => {setFields({...stepFields, phone: value});}}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
                <Col lg={8} sm={24}>
                    <InputField
                        name="email"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.email.title')}
                        required={true}
                        value={stepFields.email}
                        setValue={(value) => {setFields({...stepFields, email: value});}}
                        getFieldErrors={getFieldErrors}
                    />
                </Col>
            </Row>
            <Row>
                <Col lg={8} sm={24}>
                    <InputField
                        name="atiCode"
                        label={i18n.t('modals.modalEditLegalEntityNew.fields.atiCode.title')}
                        isDisabled={notRegisteredATI}
                        required={true}
                        value={stepFields.atiCode}
                        setValue={(value) => {setFields({...stepFields, atiCode: value});}}
                        getFieldErrors={getFieldErrors}
                    />
                    <Checkbox
                        name="notRegisteredATI"
                        checked={notRegisteredATI}
                        onChange={(e) => {
                            setFields({
                                ...stepFields,
                                atiCode: e.target.checked ? i18n.t('modals.modalEditLegalEntityNew.fields.notRegisteredATI.title') : ''
                            });
                            setNotRegisteredATI(e.target.checked)
                        }}
                        style={{fontSize: "10pt", paddingTop: "15px"}}
                    >
                      {i18n.t('modals.modalEditLegalEntityNew.fields.accreditedIntDeliveries.title')}
                    </Checkbox>
                </Col>
            </Row>
        </>
    );
}
